import { render, staticRenderFns } from "./OrgUsersOffices.vue?vue&type=template&id=482fe69a&scoped=true&"
import script from "./OrgUsersOffices.vue?vue&type=script&lang=js&"
export * from "./OrgUsersOffices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482fe69a",
  null
  
)

export default component.exports